// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Banner-module__ui-Banner--DeETG {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  min-height: 38px;
  align-items: center;
  justify-content: space-between;
}

.Banner-module__ui-Banner-Leading--e5YSR,
.Banner-module__ui-Banner-Trailing--knR6n {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}

.Banner-module__ui-Banner-Content--GOqaI {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
}

.Banner-module__title--BO8MP,
.Banner-module__content--XgI0u {
  margin: 0;
  overflow-wrap: anywhere;
}

.Banner-module__title--BO8MP {
  color: var(--chaek-color-text-primary);
  font-size: 0.8125rem; /* 13px */
  font-weight: 400;
  line-height: 1.21875rem; /* 19.5px */
  letter-spacing: -0.026636rem; /* -0.4262px */
}

.Banner-module__content--XgI0u {
  color: var(--chaek-color-text-muted);
  font-size: 0.625rem; /* 10px */
  font-weight: 400;
  line-height: 1rem; /* 16px */
  letter-spacing: -0.01455rem; /* -0.2328px */
}

.Banner-module__description--OlQcQ {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Banner/Banner.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;EAEE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,uBAAuB,EAAE,WAAW;EACpC,4BAA4B,EAAE,cAAc;AAC9C;;AAEA;EACE,oCAAoC;EACpC,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,2BAA2B,EAAE,cAAc;AAC7C;;AAEA;EACE,aAAa;AACf","sourcesContent":[".ui-Banner {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  min-height: 38px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ui-Banner-Leading,\n.ui-Banner-Trailing {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n}\n\n.ui-Banner-Content {\n  display: flex;\n  min-width: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 3px;\n}\n\n.title,\n.content {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.title {\n  color: var(--chaek-color-text-primary);\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 400;\n  line-height: 1.21875rem; /* 19.5px */\n  letter-spacing: -0.026636rem; /* -0.4262px */\n}\n\n.content {\n  color: var(--chaek-color-text-muted);\n  font-size: 0.625rem; /* 10px */\n  font-weight: 400;\n  line-height: 1rem; /* 16px */\n  letter-spacing: -0.01455rem; /* -0.2328px */\n}\n\n.description {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Banner": `Banner-module__ui-Banner--DeETG`,
	"ui-Banner-Leading": `Banner-module__ui-Banner-Leading--e5YSR`,
	"ui-Banner-Trailing": `Banner-module__ui-Banner-Trailing--knR6n`,
	"ui-Banner-Content": `Banner-module__ui-Banner-Content--GOqaI`,
	"title": `Banner-module__title--BO8MP`,
	"content": `Banner-module__content--XgI0u`,
	"description": `Banner-module__description--OlQcQ`
};
export default ___CSS_LOADER_EXPORT___;
